import { Attribute, Convention } from '../../../concepts/objects';
import { Audited } from '../auditing/Audited';

export const Concealable = new Convention<Concealable>('Concealable');

export interface Concealable extends Audited {

    concealed: boolean;
}

export const IsActuallyConcealed = new Attribute<boolean>('isActallyConcealed', false);

export const IsConcealedHintVisible = new Attribute<boolean>('IsConcealedHintVisible', false);
